<script lang="ts">
  import PillButton from "./buttons/PillButton.svelte";
  import Stack from "./Stack.svelte";
  import Text from "./Text.svelte";

  export let title: string = "";
  export let subtitle: string = "";
  export let headerTitle: string;

  export let headerTitleSize: string = "s";

  export let actionLabel: string = "";
  export let onClick: () => void = () => {};
</script>

<div class="title-container">
  <Stack horizontal justifyContent="space-between" alignItems="flex-start" padding="11px 0 0 0">
    <div>
      <Text size={headerTitleSize} ocd color="transparency-dark">{headerTitle}</Text>
      {#if actionLabel}
        <div class="panel-action">
          <PillButton color={"neutral-02"} title={actionLabel} {onClick} />
        </div>
      {/if}
    </div>

    <Stack vertical justifyContent="flex-end" alignItems="flex-end" padding="3px 0 0 0">
      {#if $$slots.content}
        <slot name="content" />
      {:else}
        <Text size="xl">{title}</Text>
        <Text size="m" color="transparency-dark">{subtitle}</Text>
      {/if}
    </Stack>
  </Stack>
</div>

<style>
  .title-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: space-between;
    justify-content: space-between;
    padding: 0px 18px 0 18px;
    border-radius: 4px;
    border-color: var(--rekki-neutral-01);
    border-width: 1px;
    border-style: solid;
    min-height: 76px;
  }

  .panel-action {
    margin-top: 10px;
  }
</style>
